export default function EmployeeDashboard() {
  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold text-purple-600">Employee Dashboard</h1>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-gradient-to-r from-purple-400 to-purple-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">My Leaves</h2>
          <p className="text-3xl mt-2">2</p>
        </div>

        <div className="bg-gradient-to-r from-blue-400 to-blue-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">Attendance</h2>
          <p className="text-3xl mt-2">95%</p>
        </div>

        <div className="bg-gradient-to-r from-green-400 to-green-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">Payslips</h2>
          <p className="text-3xl mt-2">3</p>
        </div>
      </div>

      {/* Upcoming Holidays */}
      <div className="bg-white p-6 rounded-xl shadow-lg">
        <h2 className="text-2xl font-semibold mb-4">Upcoming Holidays</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>25 Dec 2025 - Christmas</li>
          <li>01 Jan 2026 - New Year</li>
          <li>26 Jan 2026 - Republic Day</li>
        </ul>
      </div>
    </div>
  );
}
